/**
 * https://support.google.com/adsense/answer/10762946?hl=ru
 * https://developers.google.com/ad-placement/docs/placement-types
 *
 * Created by Ivan on 01.09.22
 */

const GoogleWebAds = function () { 
    AdsPlugin.call(this, connector.GOOGLE_ADS, {
        sdk: SdkManager.SDK_GOOGLE_ADS,
        cantLoadAndPlayInParallel: true,
        cantLoadAfterPlay: true
    });

    // own subscription: the BasePlugin one is cleared on disconnect, and onReady may come after the init timeout
    connector.sdk.on(SdkManager.SDK_GOOGLE_ADS, (event) => {
        if (event === "ready") {
            this.connect();
        }
    });
};

GoogleWebAds.prototype = Object.create(AdsPlugin.prototype);
GoogleWebAds.prototype.constructor = GoogleWebAds;

GoogleWebAds.isAppropriate = function () {
    return connector.config.adsense && connector.platform.oneOf(connector.CLEVERAPPS, connector.PWA, connector.MSSTART);
};

GoogleWebAds.prototype.isNoAdsProductAvailable = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS, connector.MSSTART);
};

GoogleWebAds.prototype._cacheAd = function (name, callback) {
    if (name === AdsPlugin.INTERSTITIAL) {
        callback(connector.CODE_SUCCEED, true);
        return;
    }

    window.adsbygoogle.push({
        name,
        type: "reward",
        beforeReward: (showAdFn) => {
            callback(connector.CODE_SUCCEED, showAdFn);
        },
        // the Ad Placement API rejects a reward placement without these two, the result itself comes from adBreakDone
        adViewed: () => {},
        adDismissed: () => {},
        adBreakDone: (placementInfo) => {
            const breakStatus = placementInfo && placementInfo.breakStatus;

            if (this._callback) {
                console.log("Rewarded finished", breakStatus);
                const code = GoogleWebAds.GetRewardedBreakCode(breakStatus);
                this._callback(code, code === ERRORS.SHOW_REWARDED.UNKNOWN ? breakStatus : undefined);
                this._callback = undefined;
            } else {
                callback(GoogleWebAds.GetLoadBreakCode(breakStatus));
            }
        }
    });
};

GoogleWebAds.prototype._playAd = function (name, ad, callback) {
    if (name === AdsPlugin.INTERSTITIAL) {
        window.adsbygoogle.push({
            name,
            type: "start",
            beforeAd: function () {
                console.log("Interstitial started");
            },
            adBreakDone: function (placementInfo) {
                const breakStatus = placementInfo && placementInfo.breakStatus;
                console.log("Interstitial finished", breakStatus);
                const code = GoogleWebAds.GetInterstitialBreakCode(breakStatus);
                callback && callback(code, code === ERRORS.SHOW_INTERSTITIAL.UNKNOWN ? breakStatus : undefined);
            }
        });
        return;
    }

    if (typeof ad !== "function") {
        callback && callback(ERRORS.SHOW_REWARDED.NO_ADS);
        return;
    }

    this._callback = callback;
    ad();
};

GoogleWebAds.prototype.isStickySupported = function () {
    if (connector.platform.oneOf(connector.MSSTART)) {
        return (["CN"].includes(connector._countryManager.country) || connector.config.debugMode);
    }

    return true;
};

GoogleWebAds.prototype.isStickyAvailable = function () {
    return window.innerWidth >= GoogleWebAds.AD_BANNER_WIDTH;
};

GoogleWebAds.prototype.isStickyConfigured = function () {
    return connector.config.adsense && connector.config.adsense.slot;
};

GoogleWebAds.prototype.addBannerContainer = function () {
    if (this.bannerContainer) {
        return;
    }

    const container = this.bannerContainer = document.createElement("div");
    container.style.display = "block";
    container.style.position = "absolute";
    container.style.bottom = "0";
    container.style.margin = "0 auto";
    container.style.right = "0";
    container.style.left = "0";
    container.style.height = `${GoogleWebAds.AD_BANNER_HEIGHT}px`;
    container.style.width = `${GoogleWebAds.AD_BANNER_WIDTH}px`;
    container.style.zIndex = "2";
    container.style.backgroundColor = "white";

    const ins = this.bannerIns = document.createElement("ins");
    ins.id = "google-ad-banner-container";
    ins.className = "adsbygoogle";
    ins.style.zIndex = "2";
    ins.setAttribute("data-ad-client", connector.config.adsense.client);
    ins.setAttribute("data-ad-slot", connector.config.adsense.slot);

    if (connector.config.debugMode) {
        ins.setAttribute("data-adbreak-test", "on");
        ins.setAttribute("data-ad-test", "on");
    }

    ins.style.display = "inline-block";
    ins.style.position = "relative";
    ins.style.margin = "0 auto";
    ins.style.height = `${GoogleWebAds.AD_BANNER_HEIGHT}px`;
    ins.style.width = `${GoogleWebAds.AD_BANNER_WIDTH}px`;

    document.body.appendChild(container);
    container.appendChild(ins);

    (window.adsbygoogle = window.adsbygoogle || []).push({});
};

GoogleWebAds.prototype.removeBannerContainer = function () {
    if (this.bannerObserver) {
        this.bannerObserver.disconnect();
        this.bannerObserver = undefined;
    }
    if (this.bannerIns) {
        this.bannerIns.remove();
        this.bannerIns = undefined;
    }
    if (this.bannerContainer) {
        this.bannerContainer.remove();
        this.bannerContainer = undefined;
    }
};

GoogleWebAds.prototype.showSticky = function (callback) {
    this.addBannerContainer();

    callback(connector.CODE_SUCCEED, {
        width: GoogleWebAds.AD_BANNER_WIDTH,
        height: GoogleWebAds.AD_BANNER_HEIGHT
    });
};

GoogleWebAds.prototype.closeSticky = function (callback) {
    this.removeBannerContainer();

    callback(connector.CODE_SUCCEED);
};

// adBreakDone is called even when no ad was shown; only "viewed" is a real impression
// https://developers.google.com/ad-placement/apis/adbreak#adbreakdone
GoogleWebAds.GetInterstitialBreakCode = function (breakStatus) {
    switch (breakStatus) {
        case "viewed":
        case "dismissed":
            return connector.CODE_SUCCEED;
        case "frequencyCapped":
            return ERRORS.SHOW_INTERSTITIAL.THROTTLED;
        case "noAdPreloaded":
            return ERRORS.SHOW_INTERSTITIAL.NO_ADS;
        default:
            return ERRORS.SHOW_INTERSTITIAL.UNKNOWN;
    }
};

// the reward is granted only on "viewed"; "dismissed" - the player closed the ad before the end
GoogleWebAds.GetRewardedBreakCode = function (breakStatus) {
    switch (breakStatus) {
        case "viewed":
            return connector.CODE_SUCCEED;
        case "dismissed":
            return ERRORS.SHOW_REWARDED.CLOSED_BY_USER;
        case "frequencyCapped":
            return ERRORS.SHOW_REWARDED.THROTTLED;
        case "noAdPreloaded":
            return ERRORS.SHOW_REWARDED.NO_ADS;
        default:
            return ERRORS.SHOW_REWARDED.UNKNOWN;
    }
};

GoogleWebAds.GetLoadBreakCode = function (breakStatus) {
    switch (breakStatus) {
        case "noAdPreloaded":
            return AdsPlugin.ERROR_LOADING_NO_ADS;
        default:
            return `ads_loading_google_${String(breakStatus).toLowerCase()}`;
    }
};

GoogleWebAds.AD_BANNER_WIDTH = 728;
GoogleWebAds.AD_BANNER_HEIGHT = 90;
